import { gql } from '@apollo/client';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { resetAlerts } from '../alerts';
import { selectUser } from '../auth';
import { FetchWithErrorsQuery, graphqlQueryWithErrors } from '../graphql';
import { filterServiceCallWorkOrders } from '../shared';
import { displayServiceCallAlert, getWorkOrders, setWorkOrders, setWorkOrdersError } from './workOrdersSlice';
import { waitForToken } from '../utils/utilsSagas';
import { ProductInstanceTypes } from '../../../../platform/src/server/dataSources/PSM/types';

const GET_WORK_ORDERS = gql`
  query getWorkOrders {
    getWorkOrders {
      externalWorkOrderId
      workOrderType
      schedule {
        from
        to
      }
    }
  }
`;

function* fetchWorkOrders() {
  yield call(waitForToken);

  const {
    user: { productKind },
  } = yield select(selectUser);

  if (productKind === ProductInstanceTypes.WirelessInternet) return;

  const workOrdersResponse: FetchWithErrorsQuery = yield call(graphqlQueryWithErrors, {
    query: GET_WORK_ORDERS,
    fetchPolicy: 'network-only',
  });

  const { data, errors, runtimeError } = workOrdersResponse;

  if (errors || runtimeError) {
    yield put(setWorkOrdersError(runtimeError ?? errors));
    return;
  }

  if (data?.getWorkOrders) {
    yield put(setWorkOrders(data?.getWorkOrders));

    const serviceCallWorkOrders = filterServiceCallWorkOrders(data?.getWorkOrders);

    if (serviceCallWorkOrders.length > 0 && serviceCallWorkOrders[0].schedule) {
      yield put(displayServiceCallAlert(serviceCallWorkOrders[0]));
    }
  }
}

export function* watchWorkOrders() {
  yield all([takeLatest(getWorkOrders.type, fetchWorkOrders), takeLatest(resetAlerts.type, fetchWorkOrders)]);
}
